module.exports = __webpack_public_path__ + "img/ef8f80d.png";